import Box from '@mui/material/Box';
import { ENUMS_MINI_BANNER_IMAGE_LAYOUT } from 'constants/Enums/mini-banner';
import useOnScreen from 'hooks/useOnScreen';
import { useEffect, useRef, useState } from 'react';
import { ImageFallbackBanner } from 'utils/ImageFallback';
import { debounceFunc300 } from 'utils/debounce';
import gtag from 'utils/gtag';
import styles from './styles.module.css';
import { useAuth } from 'context/Auth';
import { getMiniBanners } from 'services/WebService';

export default function MiniBannerBlock({ defaultMiniBanners = [] }) {
  const [miniBanners, setMiniBanners] = useState(defaultMiniBanners);
  const { user } = useAuth();

  useEffect(() => {
    (async () => {
      const banners = await getMiniBanners({ user });
      setMiniBanners(banners);
    })();
  }, [user?.provinceCode, user?.customerID]);

  const isBannerSize4 = miniBanners?.length === ENUMS_MINI_BANNER_IMAGE_LAYOUT.MINI_BANNERS_SIZE_4.quantity;

  const bannerRefs = useRef([]);
  const wrapperRef = useRef(null);
  const visible = useOnScreen(wrapperRef);
  const getVisibleElements = (eventRefs) => {
    const elements = eventRefs.current;
    const visible = [];
    elements?.forEach((element, index) => {
      const rect = element?.getBoundingClientRect();
      const isVisible = rect.left >= 0 && rect.right <= window.innerWidth;
      if (isVisible) {
        visible.push(index);
      }
    });
    return visible;
  };
  const executeAfterDebounce = (visibleElements) => {
    visibleElements.forEach((element) => {
      gtag.showMiniBanner({ link: miniBanners[element], total: miniBanners.length });
    });
  };

  useEffect(() => {
    if (visible) {
      const visibleElements = getVisibleElements(bannerRefs);
      debounceFunc300(() => {
        executeAfterDebounce(visibleElements);
      });
    }
  }, [visible]);

  if (!miniBanners?.length) {
    return <></>;
  }

  return (
    <div className={styles.miniBannerBlockWrapper} ref={wrapperRef}>
      <div className={styles.gridImagesWrapper}>
        <div className={styles.gridImages}>
          {miniBanners.map((banner, index) => (
            <Box
              key={banner.imageURL}
              ref={(el) => {
                bannerRefs.current[index] = el;
              }}
              onClick={() => {
                gtag.clickMiniBanner({ link: banner, total: miniBanners.length });
              }}
              className={styles[`${isBannerSize4 ? 'miniBannerImageSize4' : 'miniBannerImageSize5'}_${index + 1}`]}
            >
              <a href={banner?.url || '/'} target="_blank" rel="noopener noreferrer">
                {banner?.imageURL && <ImageFallbackBanner src={banner.imageURL} layout="fill" objectFit="cover" width={1500} />}
              </a>
            </Box>
          ))}
        </div>
      </div>
    </div>
  );
}
